import React from 'react';
import PropTypes from 'prop-types';
import RsSlidableNavigationPrev from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidableNavigationPrev';
import RsSlidableNavigationNext from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidableNavigationNext';

export default function RsSlidableNavigationRightSide({ prevDisabled, nextDisabled, goPrev = () => {}, goNext = () => {} }) {
  return (
    <div className="rs-slidable-navigation rs-slidable-navigation--right-side">
      <RsSlidableNavigationPrev disabled={prevDisabled} onClick={goPrev} />
      <RsSlidableNavigationNext disabled={nextDisabled} onClick={goNext} />
    </div>
  );
}

RsSlidableNavigationRightSide.propTypes = {
  prevDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  goPrev: PropTypes.func,
  goNext: PropTypes.func,
};
